import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  makeStyles,
  Switch,
  TextField,
  Theme,
  Typography,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import EditIcon from "@material-ui/icons/Edit";
import { Tooltip } from "@mui/material";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Prompt } from "react-router-dom";
import {
  getAllSecondaryInspection,
  getSecondaryInspectionVehicles,
  updateSecondaryInspection,
} from "src/app-redux/customs/actions/customsActions";
import { loader } from "src/app-redux/customs/customsSlice";
import { useAppSelector } from "src/app-redux/hooks";
import { getSecondaryInspectionDepartments } from "src/app-redux/vehicle/actions/vehicleActions";
import { customColorCodeList, filteryByArr } from "src/common/utils/app.dropdowns";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import TabHeader from "src/components/TabHeader/TabHeader";
import * as Yup from "yup";
import { VehicleManagementRoute } from "../../vehicle-management.routes";
import { columns } from "./components/columns";
import { filterBy } from "src/common/utils/helpers";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));

interface Props {}

export function SecondaryInspection({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [moduleName, setmoduleName] = useState<any>(VehicleManagementRoute.title);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [pageHeading, setpageHeading] = useState<any>("Secondary Inspection");
  const [loader2, setLoader] = useState<any>(false);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleNumber, setVehicleNumber] = useState<any>("");
  const [isEditMode, setisEditMode] = React.useState<boolean>(false);
  const loading = useAppSelector(loader);
  let vehicleRegArr: any[] = [];
  const secondaryInspectionArr = ["Cleared", "Not Cleared"];
  const [departmentsList, setDepartmentsList] = useState<any[]>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const [resetHandler, setResetHandler] = useState(false);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    setLoader(true);
    handleSearch();
    getDepartmentList();
  }, []);

  const getDepartmentList = async () => {
    const res: any = await dispatch(getSecondaryInspectionDepartments());
    if (res.payload) {
      setDepartmentsList(res.payload);
    }
  };

  /* AXIOS Calls */
  const getVehicleByRegistrationNo = async (queryString: string) => {
    const results: any = await dispatch(getSecondaryInspectionVehicles(queryString));
    if (results.payload) {
      setvehicleRegNumberArr(results.payload);
      vehicleRegArr = results.payload;
    }
    return;
  };
  /*./AXIOS Calls */

  const { height } = UseWindowDimensions();
  let dppr = 10;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  const validationSchema = Yup.object().shape({
    registrationNumber: Yup.string().required("This field is required"),
    comments: Yup.string()
      .required("This field is required")
      .max(3000, "Maximum 3000 characters allowed"),
  });
  const formik = useFormik({
    initialValues: {
      id: 0,
      registrationNumber: "",
      gatePassScanId: 0,
      secondaryScanDecision: "Not Cleared",
      comments: "",
      assignedDepartmentId: 0,

      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      InProgressVehiclesDataOnly: true,
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      if (values.gatePassScanId == 0) {
        dispatch(
          addNotificationAction({
            message: "Select vehicle number first!",
            options: { variant: "error" },
          })
        );
        return;
      }
      setLoader(true);
      const payload = {
        id: values.id,
        gatePassScanId: values.gatePassScanId,
        assignedDepartmentId: values.assignedDepartmentId,
        comments: values.comments,
        secondaryScanDecision: values.secondaryScanDecision,
        vehicleNumber: values.registrationNumber,
      };
      const res: any = await dispatch(updateSecondaryInspection(payload));

      if (res.payload) {
        handleSearch();
        setisEditMode(false);
        actions.setSubmitting(false);
        actions.resetForm();
        setIsDirty(false);
        setvehicleRegNumberArr([]);
      }
      setLoader(false);
    },
  });

  const { values, setValues } = formik;

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(getAllSecondaryInspection(body));
      if (results.payload) {
        const transformedData = results.payload.map((data: any, index: any) => {
          return data;
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const resetSearch = () => {
    setValues({
      ...formik.initialValues,
      filterBy: values.filterBy,
      startDate: values.startDate,
      endDate: values.endDate,
      InProgressVehiclesDataOnly: values.InProgressVehiclesDataOnly,
    });
    setIsDirty(false);
    setisEditMode(false);
  };
  const resetGrid = async () => {
    setValues({
      ...formik.values,
      InProgressVehiclesDataOnly: formik.initialValues.InProgressVehiclesDataOnly,
      filterBy: formik.initialValues.filterBy,
      startDate: formik.initialValues.startDate,
      endDate: formik.initialValues.endDate,
    });
    setIsCustomDate(false);
    setResetHandler(true);
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    setLoader(true);
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };
  const handleUpdateClick = async (params: any) => {
    setisEditMode(true);

    formik.setFieldValue("registrationNumber", params.vehicleNumber);
    formik.setFieldValue("id", params.id);
    formik.setFieldValue("gatePassScanId", params.gatePassScanId);
    formik.setFieldValue("secondaryScanDecision", params.secondaryScanDecision || "Not Cleared");
    formik.setFieldValue("comments", params.comments ?? "");
    formik.setFieldValue("assignedDepartmentId", params.assignedDepartmentId);
  };
  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "comments"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "actionButtons"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        setIsDirty(true);
                        handleUpdateClick(row.original);
                      }}
                      icon={<EditIcon />}
                      isEdit={true}
                      disable={!Boolean(row.original.vehicleInProgress)}
                    >
                      Edit
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column.accessorKey === "webocRMSColorCode"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <div>
                    {
                      customColorCodeList.find((color: any) => color.value == renderedCellValue)
                        ?.name
                    }
                  </div>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);

  function handleChange(e: any) {
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (!loader2) formik.submitForm();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [loader2]);

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        Vehicle: data?.vehicleNumber,
        "Secondary Inspection": data?.secondaryScanDecision,
        "Assigned Department": data?.departmentName,
        Remarks: data?.comments,
      };
    });
    return exportedRecords;
  };

  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={VehicleManagementRoute.path} />
      <Backdrop className={classes.backdrop} open={loader2 || loading}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => formik.submitForm()}
                >
                  Update
                  {/* {isEditMode ? "Update" : "Save"} */}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              {/* Vehicle Number */}
              <Grid item xs={12} md={4}>
                <Box style={{ display: isEditMode ? "none" : "block" }}>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Vehicle Number"
                    placeholder="Enter Vehicle Number"
                    name="registrationNumber"
                    optionsType={vehicleRegNumberArr}
                    getOptionLabel={(option) => option.vehicleNumber || ""}
                    required
                    value={
                      vehicleRegNumberArr.find(
                        (st: any) => st.vehicleNumber === formik.values.registrationNumber
                      ) || null
                    }
                    onChange={(option: any) => {
                      if (option && option.vehicleNumber !== "" && option.vehicleId !== 0) {
                        setValues({
                          ...values,
                          registrationNumber: option.vehicleNumber,
                          gatePassScanId: option.gatePassScanId,
                          id: option.id,
                          secondaryScanDecision: option.secondaryScanDecision || "Not Cleared",
                          comments: option.secondaryScanComments || "",
                          assignedDepartmentId: option.assignedDepartmentId,
                        });
                        handleChange({ target: { value: option.vehicleId } });
                      } else {
                        formik.setFieldValue("registrationNumber", "");
                        handleChange({ target: { value: null } });
                      }
                    }}
                    onKeyUp={(e: any) => {
                      setVehicleNumberLength(e.target.value.length);
                      setVehicleNumber(e.target.value);

                      if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                        getVehicleByRegistrationNo(e.target.value);
                        return;
                      }
                    }}
                    onKeyDownCapture={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                      else handleChange(e);
                    }}
                    onPaste={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                        return;
                      }

                      if (e.clipboardData.getData("text").length >= 2)
                        getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                    }}
                    error={
                      formik.touched.registrationNumber && Boolean(formik.errors.registrationNumber)
                    }
                    helperText={
                      formik.touched.registrationNumber && formik.errors.registrationNumber
                    }
                  />
                </Box>
                <Box style={{ display: isEditMode ? "block" : "none" }}>
                  <TextField
                    className={"customTextField"}
                    required
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Vehicle Number"
                    name="registrationNumber"
                    id="registrationNumber"
                    placeholder="Enter Vehicle Number"
                    disabled={true}
                    value={formik.values.registrationNumber}
                    error={
                      formik.touched.registrationNumber && Boolean(formik.errors.registrationNumber)
                    }
                    helperText={
                      formik.touched.registrationNumber && formik.errors.registrationNumber
                    }
                  />
                </Box>
              </Grid>
              {/* Secondary Inspection */}
              <Grid item xs={12} md={4}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  label="Secondary Inspection"
                  placeholder="Select Secondary Inspection"
                  optionsType={secondaryInspectionArr}
                  getOptionLabel={(option: any) => option || ""}
                  onChange={(value: any) => {
                    setValues({
                      ...values,
                      secondaryScanDecision: value || "",
                      assignedDepartmentId: value === "Cleared" ? 0 : values.assignedDepartmentId,
                    });
                    handleChange({ target: { value: value } });
                  }}
                  value={
                    secondaryInspectionArr.find(
                      (value: any) => value === formik.values.secondaryScanDecision
                    ) || ""
                  }
                  disabled={false}
                  error={
                    formik.touched.secondaryScanDecision &&
                    Boolean(formik.errors.secondaryScanDecision)
                  }
                  helperText={
                    formik.touched.secondaryScanDecision && formik.errors.secondaryScanDecision
                  }
                />
              </Grid>
              {/* Change Department */}
              <Grid item xs={12} md={4}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  label="Change Department"
                  placeholder="Select Department"
                  optionsType={departmentsList}
                  getOptionLabel={(option: any) => option.name || ""}
                  onChange={(value: any) => {
                    setValues({ ...values, assignedDepartmentId: value.id || 0 });
                    handleChange({ target: { value: value.id } });
                  }}
                  value={
                    departmentsList.find(
                      (value: any) => value.id === formik.values.assignedDepartmentId
                    ) || ""
                  }
                  disabled={formik.values.secondaryScanDecision === "Cleared"}
                  error={
                    formik.touched.assignedDepartmentId &&
                    Boolean(formik.errors.assignedDepartmentId)
                  }
                  helperText={
                    formik.touched.assignedDepartmentId && formik.errors.assignedDepartmentId
                  }
                />
              </Grid>
              {/* Comments */}
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    multiline
                    rows={1}
                    rowsMax={8}
                    className="customTextField"
                    required
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Remarks"
                    name="comments"
                    placeholder="Enter Remarks"
                    disabled={false}
                    value={formik.values.comments}
                    onChange={handleChange}
                    error={formik.touched.comments && Boolean(formik.errors.comments)}
                    helperText={formik.touched.comments && formik.errors.comments}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
          <Box style={{ marginTop: "30px", marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={3} lg={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter by"
                  placeholder="Filter by"
                  name="filterBy"
                  disableClearable={true}
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || ""}
                  onChange={(row: any) => {
                    row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                      onChange={formik.handleChange}
                      name="InProgressVehiclesDataOnly"
                      color="primary"
                    />
                  }
                  label="In Progress Vehicles"
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 12 : 5} lg={isCustomDate ? 4 : 8}>
                <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                  <CommonButton cssClass="customSubmitBtn" onClick={() => resetGrid()}>
                    Reset
                  </CommonButton>
                  <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                    Search
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <div className="">
            <CommonMaterialGrid
              rows={vehicleRecord}
              columns={displayColumns}
              defaultPerPageRecord={15}
              height={550}
              isExport={isExport}
              exportHandler={exportHandler}
              filename={`Vehicle_Secondary_weight_${Date.now()}`}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
